class Tracks {
  constructor ({ baseUrl, files }) {
    this.files = []
    files.forEach(({ file }) => {
      this.files.push(`${baseUrl}${file}`)
    })
  }

  getFiles () {
    return this.files
  }
}

export default Tracks
